import styled from 'styled-components';

import { Label } from '@r1-frontend/ui-react/components/label';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';
import { hex2rgb } from '@r1-frontend/shared/helpers/hex2rgb';

export const CountPrice = styled.div`
    position: relative;
    width: 123px;
    height: 80px;
    padding: 8px 12px;
    gap: 4px;
    border: 2px solid ${COLORS.BgMain};
    border-radius: ${BorderRadius.componentRadius};
    background-color: rgba(${hex2rgb(COLORS.BgMain)}, 0.5);
`;

export const DiscountLabel = styled(Label)`
    position: absolute;
    top: 8px;
    right: -15px;
    flex-direction: column;
    transform: rotate(-4deg);
`;

export const DiscountUpTo = styled.p`
    ${FONTS.MediumXXXS};
    margin-left: -5px;
    margin-bottom: -4px;
`;

export const DiscountValue = styled.p`
    ${FONTS.H6};
`;

export const Count = styled.p<{ textColor: COLORS }>`
    ${FONTS.H3};
    color: ${p => p.textColor};
`;

export const Price = styled.p`
    ${FONTS.H5};
    color: ${COLORS.TextSecondary};
`;
